

// // 5. Modify the TextField component to accept the 'disabled' prop
// export const TextField = ({
//   label,
//   placeholder,
//   type = "text",
//   startIcon,
//   name,
//   defaultValue,
//   disabled, // Receive the new disabled prop
// }) => (
//   <div className="space-y-1">
//     <label className="block text-xs font-medium input-lable my-3">
//       {label}
//     </label>
//     <div className="relative">
//       {startIcon && (
//         <span className="absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400">
//           <img
//             src={startIcon}
//             alt="connet"
//             className="w-5 h-5"
//           />        </span>
//       )}
//       <input
//         type={type}
//         name={name}
//         defaultValue={defaultValue}
//         placeholder={placeholder}
//         disabled={disabled} // Apply the disabled attribute to the input
//         className={[
//           "w-full h-11 rounded-[13px] border bg-white text-gray-800 placeholder:text-gray-400 ",
//           "px-4 py-3 outline-none transition",
//           "focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//           "border-[#E6E2FF] shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//           disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "", // Optional: Add styles for disabled state
//           startIcon ? "pl-10" : "",
//         ].join(" ")}
//       />
//     </div>
//   </div>
// );

// import React, { useState } from "react";

// export const TextField = ({
//   label,
//   required,      // ✅ add this
//   placeholder,
//   type = "text",
//   startIcon,
//   name,
//   rightIcon,      // optional custom right icon
//   defaultValue,
//   disabled,
//   inputclassName,
//   value,          // ✅ add this
//   onChange,       // ✅ add this
//   error,          // ✅ show validation error
//   // select helpers
//   select,         // render a <select> instead of input
//   selectType,     // 'year' to auto-generate years
//   options,        // array of { value, label }
//   startYear = 1950,
// }) => {
//   const [showPassword, setShowPassword] = useState(false);

//   const isPasswordField = type === "password";
//   const inputType = isPasswordField && showPassword ? "text" : type;

//   return (
//     <div className={`space-y-1 ${inputclassName}`}>
//       {label && (
//         <label className="block text-xs font-medium input-lable my-3">
//           {label}
//         </label>
//       )}

//       <div className="relative">
//         {startIcon && (
//           <span className="absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400">
//             <img src={startIcon} alt="" className="w-5 h-5" />
//           </span>
//         )}

//         {/* Render select when requested */}
//         {select ? (
//           <select
//             name={name}
//             value={value}
//             onChange={onChange}
//             disabled={disabled}
//             required={required}
//             className={[
//               "w-full h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
//               "px-4 py-3 outline-none transition",
//               error
//                 ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
//                 : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//               "shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//               disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "",
//               startIcon ? "pl-10" : "",
//             ].join(" ")}
//           >
//             <option value="">Select</option>
//             {options && options.length > 0
//               ? options.map((opt) => (
//                 <option key={opt.value ?? opt} value={opt.value ?? opt}>
//                   {opt.label ?? opt}
//                 </option>
//               ))
//               : selectType === "year"
//                 ? Array.from({ length: new Date().getFullYear() - startYear + 1 }, (_, i) => startYear + i).map((yr) => (
//                   <option key={yr} value={String(yr)}>
//                     {yr}
//                   </option>
//                 ))
//                 : null}
//           </select>
//         ) : (
//           <>
//             <input
//               type={inputType}
//               name={name}
//               value={value}             // ← controlled input
//               onChange={onChange}       // ← pass event up
//               placeholder={placeholder}
//               disabled={disabled}
//               defaultValue={defaultValue}
//               required={required}       // ✅ add required attribute
//               className={[
//                 "w-full h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
//                 "px-4 py-3 outline-none transition",
//                 error
//                   ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
//                   : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//                 "shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//                 disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "",
//                 startIcon ? "pl-10" : "",
//                 (isPasswordField || rightIcon) ? "pr-10" : "",
//               ].join(" ")}
//             />

//             {(isPasswordField || rightIcon) && (
//               <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
//                 {isPasswordField ? (
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="focus:outline-none mt-2"
//                   >
//                     {showPassword ? (
//                       <img src={"./input-logos/eye.svg"} alt="" className="w-5 h-5" />
//                     ) : (
//                       <img src={"./input-logos/eye.svg"} alt="" className="w-5 h-5" />
//                     )}
//                   </button>
//                 ) : (
//                   <img src={rightIcon} alt="" className="w-5 h-5" />
//                 )}
//               </div>
//             )}
//           </>
//         )}
//       </div>
//       {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
//     </div>
//   );
// };



import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useRef, useEffect } from "react";

export default function CustomSelect({
  value,
  onChange,
  options = [],
  required,
  disabled,
  error,
  placeholder = "Select"
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // close dropdown click outside
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const isEmpty = !value || !value.value;

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* MAIN BOX */}
      <button
        type="button"
        onClick={() => !disabled && setOpen((prev) => !prev)}
        disabled={disabled}
        className={`
         w-[99%] h-11 rounded-[13px] text-gray-800
          px-4 flex items-center justify-between gap-2
          border
          shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]
          focus:ring-4
          ${disabled ? 'cursor-not-allowed opacity-70 bg-white' : 'bg-white'}
          ${error ?
            'border-red-500 focus:border-red-500 focus:ring-red-100' :
            'border-[#E6E2FF] focus:border-violet-500 focus:ring-violet-500/10'
          }
        `}
      >
        <span className={`min-w-0 flex-1 truncate text-left ${isEmpty ? 'text-gray-400' : 'text-gray-800'}`}>{value?.label || placeholder}</span>
        <img src="./chatbar/dark-arrow.svg" className={`w-4 h-4 shrink-0 opacity-60 ${open ? '-rotate-90' : 'rotate-90'}`} />
      </button>

      {/* DROPDOWN MENU */}
      {open && !disabled && (
        <div
          className="
            absolute mt-1 w-full bg-white rounded-xl shadow-xl z-[9999] 
            max-h-60 overflow-y-auto border border-gray-200
          "
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className="
                px-4 py-2 cursor-pointer text-gray-700 text-sm 
                hover:bg-violet-100
              "
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export const TextField = ({
  label,
  required,
  placeholder,
  type = "text",
  startIcon,
  name,
  rightIcon,
  defaultValue,
  disabled,
  inputclassName,
  value,
  onChange,
  error,
  select,
  selectType,
  options,
  startYear = 1950,
  endYear = new Date().getFullYear(),
  minMonth,
  maxMonth,
  minDate,
  maxDate,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [monthPickerYear, setMonthPickerYear] = useState(new Date().getFullYear());
  const [dateViewYear, setDateViewYear] = useState(new Date().getFullYear());
  const [dateViewMonth, setDateViewMonth] = useState(new Date().getMonth() + 1);
  const [monthPickerStyle, setMonthPickerStyle] = useState({ top: 0, left: 0, width: 0 });
  const [datePickerStyle, setDatePickerStyle] = useState({ top: 0, left: 0, width: 0 });
  const dateInputRef = useRef(null);
  const monthInputRef = useRef(null);
  const monthPickerRef = useRef(null);
  const datePickerRef = useRef(null);
  const isPasswordField = type === "password";
  const isNumberField = type === "number";
  const isDateField = type === "date";
  const isMonthField = type === "month";
  const inputType = isPasswordField && showPassword ? "text" : (isMonthField || isDateField ? "text" : type);
  const isTimeField = type === "time";
  const timeInputRef = useRef(null);

  const parseMonthBound = (val) => {
    const text = String(val ?? "").trim();
    const match = text.match(/^(\d{4})-(\d{2})$/);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (Number.isNaN(year) || Number.isNaN(month) || month < 1 || month > 12) return null;
    return { year, month };
  };

  const compareMonth = (left, right) => {
    if (!left || !right) return 0;
    if (left.year !== right.year) return left.year - right.year;
    return left.month - right.month;
  };

  const minMonthBound = parseMonthBound(minMonth);
  const maxMonthBound = parseMonthBound(maxMonth);

  const clampYearToBounds = (year) => {
    let nextYear = year;
    if (minMonthBound && nextYear < minMonthBound.year) nextYear = minMonthBound.year;
    if (maxMonthBound && nextYear > maxMonthBound.year) nextYear = maxMonthBound.year;
    return nextYear;
  };

  const formatMonthDisplay = (val) => {
    if (!val) return "";
    const text = String(val).trim();
    const match = text.match(/^(\d{4})-(\d{2})$/);
    if (match) {
      const monthName = monthOptions.find((month) => month.value === match[2])?.label || match[2];
      return `${monthName} ${match[1]}`;
    }
    const displayMatch = text.match(/^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{4})$/i);
    if (displayMatch) return `${displayMatch[1]} ${displayMatch[2]}`;
    return text;
  };

  const parseMonthValue = (val) => {
    const text = String(val ?? "").trim();
    const match = text.match(/^(\d{2})\s+(\d{4})$/);
    if (match) return `${match[2]}-${match[1]}`;
    return val;
  };

  const monthOptions = [
    { value: "01", label: "Jan" },
    { value: "02", label: "Feb" },
    { value: "03", label: "Mar" },
    { value: "04", label: "Apr" },
    { value: "05", label: "May" },
    { value: "06", label: "Jun" },
    { value: "07", label: "Jul" },
    { value: "08", label: "Aug" },
    { value: "09", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const weekdayLabels = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

  const parseISODate = (val) => {
    const text = String(val ?? "").trim();
    const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) return null;
    return { year, month, day };
  };

  const toISODateString = (year, month, day) =>
    `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

  const formatDateDisplay = (val) => {
    const parsed = parseISODate(val);
    if (!parsed) return "";
    return `${String(parsed.day).padStart(2, "0")}/${String(parsed.month).padStart(2, "0")}/${parsed.year}`;
  };

  const compareDates = (left, right) => {
    if (!left || !right) return 0;
    if (left.year !== right.year) return left.year - right.year;
    if (left.month !== right.month) return left.month - right.month;
    return left.day - right.day;
  };

  const minDateBound = parseISODate(minDate);
  const maxDateBound = parseISODate(maxDate);

  const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

  const getFirstWeekday = (year, month) => new Date(year, month - 1, 1).getDay();

  const isDateDisabled = (year, month, day) => {
    const current = { year, month, day };
    if (minDateBound && compareDates(current, minDateBound) < 0) return true;
    if (maxDateBound && compareDates(current, maxDateBound) > 0) return true;
    return false;
  };

  const dateYearOptions = Array.from(
    { length: Math.max(1, endYear - startYear + 1) },
    (_, i) => startYear + i
  ).filter((yr) => {
    if (minDateBound && yr < minDateBound.year) return false;
    if (maxDateBound && yr > maxDateBound.year) return false;
    return true;
  });

  useEffect(() => {
    if (!isMonthField) return;
    const display = formatMonthDisplay(value);
    const match = display.match(/^(\d{2})\s+(\d{4})$/);
    if (match) {
      setMonthPickerYear(clampYearToBounds(Number(match[2])));
      return;
    }
    setMonthPickerYear(clampYearToBounds(new Date().getFullYear()));
  }, [value, isMonthField, minMonth, maxMonth]);

  useEffect(() => {
    if (!isDateField) return;
    const parsed = parseISODate(value);
    if (parsed) {
      setDateViewYear(parsed.year);
      setDateViewMonth(parsed.month);
    }
  }, [value, isDateField]);

  useEffect(() => {
    const handler = (e) => {
      if (monthPickerRef.current && !monthPickerRef.current.contains(e.target)) {
        setShowMonthPicker(false);
      }
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(e.target) &&
        dateInputRef.current &&
        !dateInputRef.current.contains(e.target)
      ) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const updateMonthPickerPosition = () => {
    if (!monthInputRef.current) return;
    const rect = monthInputRef.current.getBoundingClientRect();
    const MONTH_PICKER_HEIGHT = 280;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openAbove = spaceBelow < MONTH_PICKER_HEIGHT + 12 && spaceAbove > spaceBelow;
    const top = openAbove
      ? Math.max(12, rect.top - MONTH_PICKER_HEIGHT - 8)
      : rect.bottom + 8;

    setMonthPickerStyle({
      top,
      left: rect.left,
      width: rect.width,
    });
  };

  useEffect(() => {
    if (!isMonthField || !showMonthPicker) return;

    const handleReposition = () => updateMonthPickerPosition();
    handleReposition();

    // Use capture to catch scroll events from nested scroll containers.
    window.addEventListener("scroll", handleReposition, true);
    window.addEventListener("resize", handleReposition);

    return () => {
      window.removeEventListener("scroll", handleReposition, true);
      window.removeEventListener("resize", handleReposition);
    };
  }, [isMonthField, showMonthPicker]);

  const monthOptionsForYear = monthOptions.filter((month) => {
    const current = { year: monthPickerYear, month: Number(month.value) };
    if (minMonthBound && compareMonth(current, minMonthBound) < 0) return false;
    if (maxMonthBound && compareMonth(current, maxMonthBound) > 0) return false;
    return true;
  });

  const yearOptions = Array.from(
    { length: Math.max(1, new Date().getFullYear() + 10 - startYear + 1) },
    (_, i) => startYear + i
  ).filter((yr) => {
    if (minMonthBound && yr < minMonthBound.year) return false;
    if (maxMonthBound && yr > maxMonthBound.year) return false;
    return true;
  });

  const { onClick: restOnClick, onFocus: restOnFocus, onBlur: restOnBlur, onKeyDown: restOnKeyDown, ...inputRest } = rest;

  const DATE_PICKER_WIDTH = 260;
  const DATE_PICKER_HEIGHT = 320;

  const updateDatePickerPosition = () => {
    if (!dateInputRef.current) return;
    const rect = dateInputRef.current.getBoundingClientRect();
    let left = rect.left;
    const maxLeft = window.innerWidth - DATE_PICKER_WIDTH - 12;
    if (left > maxLeft) left = maxLeft;
    if (left < 12) left = 12;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openAbove = spaceBelow < DATE_PICKER_HEIGHT + 12 && spaceAbove > spaceBelow;
    const top = openAbove
      ? Math.max(12, rect.top - DATE_PICKER_HEIGHT - 8)
      : rect.bottom + 8;

    setDatePickerStyle({
      top,
      left,
      width: DATE_PICKER_WIDTH,
    });
  };

  useEffect(() => {
    if (!isDateField || !showDatePicker) return;

    const handleReposition = () => updateDatePickerPosition();
    handleReposition();

    window.addEventListener("scroll", handleReposition, true);
    window.addEventListener("resize", handleReposition);

    return () => {
      window.removeEventListener("scroll", handleReposition, true);
      window.removeEventListener("resize", handleReposition);
    };
  }, [isDateField, showDatePicker]);

  const openDatePicker = () => {
    if (disabled || !isDateField) return;
    const parsed = parseISODate(value);
    if (parsed) {
      setDateViewYear(parsed.year);
      setDateViewMonth(parsed.month);
    } else {
      const today = new Date();
      setDateViewYear(today.getFullYear());
      setDateViewMonth(today.getMonth() + 1);
    }
    updateDatePickerPosition();
    setShowDatePicker(true);
  };

  const shiftDateViewMonth = (delta) => {
    let nextMonth = dateViewMonth + delta;
    let nextYear = dateViewYear;
    while (nextMonth < 1) {
      nextMonth += 12;
      nextYear -= 1;
    }
    while (nextMonth > 12) {
      nextMonth -= 12;
      nextYear += 1;
    }
    if (minDateBound && nextYear < minDateBound.year) return;
    if (maxDateBound && nextYear > maxDateBound.year) return;
    if (minDateBound && nextYear === minDateBound.year && nextMonth < minDateBound.month) return;
    if (maxDateBound && nextYear === maxDateBound.year && nextMonth > maxDateBound.month) return;
    setDateViewYear(nextYear);
    setDateViewMonth(nextMonth);
  };

  const buildDateCalendarCells = () => {
    const daysInMonth = getDaysInMonth(dateViewYear, dateViewMonth);
    const firstWeekday = getFirstWeekday(dateViewYear, dateViewMonth);
    const cells = [];

    for (let i = 0; i < firstWeekday; i += 1) {
      cells.push({ type: "empty", key: `empty-${i}` });
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
      cells.push({ type: "day", day, key: `day-${day}` });
    }

    return cells;
  };

  const selectedDate = parseISODate(value);
  const todayDate = (() => {
    const today = new Date();
    return { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
  })();

  const handleFocus = (e) => {
    if (isDateField || isMonthField) {
      e.target.blur();
      return;
    }
    setIsFocused(true);
    if (typeof restOnFocus === "function") restOnFocus(e);
  };
  const handleBlur = (e) => {
    setIsFocused(false);
    if (typeof restOnBlur === "function") restOnBlur(e);
  };

  const handleKeyDown = (e) => {
    if (isNumberField && ["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (isDateField && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      if (!disabled) openDatePicker();
      return;
    }
    if (isMonthField && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      if (!disabled) {
        updateMonthPickerPosition();
        setShowMonthPicker((prev) => !prev);
      }
      return;
    }
    if (typeof restOnKeyDown === "function") restOnKeyDown(e);
  };

  const handleDateFieldPointerDown = (e) => {
    if (disabled) return;
    e.preventDefault();
  };

  const handleNumberChange = (e) => {
    const digitsOnly = String(e.target.value || "").replace(/\D+/g, "");
    onChange({ target: { name, value: digitsOnly } });
  };

  const handleInputClick = (e) => {
    if (isMonthField) {
      updateMonthPickerPosition();
      setShowMonthPicker((prev) => !prev);
      return;
    }
    if (isDateField) {
      if (showDatePicker) {
        setShowDatePicker(false);
        return;
      }
      openDatePicker();
      return;
    }
    if (isTimeField && timeInputRef.current?.showPicker) {
      timeInputRef.current.showPicker();
    }
    if (typeof restOnClick === "function") restOnClick(e);
  };

  return (
    <div className={`space-y-1 ${inputclassName}`}>
      {label && (
        <label className="block text-xs font-medium input-lable my-3">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        {startIcon && (
          <span className={`absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400 ${isDateField || isTimeField ? "pointer-events-none" : ""}`}>
            <img src={startIcon} alt="" className="w-5 h-5" />
          </span>
        )}

        {/* ---------- SELECT FIELD ---------- */}
        {select ? (
          <CustomSelect
            value={options?.find((o) => o.value === value)}
            onChange={(opt) =>
              onChange({ target: { name, value: opt.value } })
            }
            required={required}
            options={options}
            placeholder="Select"
            disabled={disabled}
            error={error}
          />
        ) : (
          <>
            {/* ---------- INPUT FIELD ---------- */}
            <input
              ref={isDateField ? dateInputRef : isMonthField ? monthInputRef : isTimeField ? timeInputRef : null}
              type={inputType}
              name={name}
              value={isMonthField ? formatMonthDisplay(value) : isDateField ? formatDateDisplay(value) : value}
              onChange={isMonthField ? (e) => onChange({ target: { name, value: parseMonthValue(e.target.value) } }) : isNumberField ? handleNumberChange : onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              placeholder={isDateField ? "DD/MM/YYYY" : placeholder}
              disabled={disabled}
              defaultValue={defaultValue}
              required={required}
              readOnly={isMonthField || isDateField}
              inputMode={isMonthField || isDateField ? "none" : undefined}
              onMouseDown={isDateField || isMonthField ? handleDateFieldPointerDown : undefined}
              onClick={handleInputClick}
              {...inputRest}
              className={[
                "w-[99%] h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
                "px-4 mr-2 py-3 outline-none transition border ",
                // Show ellipsis when not focused and content overflows
                !isFocused ? "truncate" : "",
                disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : isDateField ? "cursor-pointer" : "",
                startIcon ? "pl-10" : "",
                (isPasswordField || rightIcon || isMonthField || isTimeField) ? "pr-10" : "",
                error
                  ? "!border-red-500 !focus:border-red-500 focus:ring-4 focus:ring-red-100"
                  : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10 shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
              ].join(" ")}
            />

            {(isPasswordField || rightIcon || isMonthField) && (
              <div className="absolute right-3 top-[51%] -translate-y-1/2 text-gray-400">
                {isPasswordField ? (
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="focus:outline-none mt-2"
                  >
                    <img
                      src={"./input-logos/eye.svg"}
                      alt=""
                      className="w-5 h-5"
                    />
                  </button>
                ) : isMonthField ? (
                  <button
                    type="button"
                    onClick={() => {
                      if (disabled) return;
                      updateMonthPickerPosition();
                      setShowMonthPicker((prev) => !prev);
                    }}
                    className="focus:outline-none cursor-pointer"
                    disabled={disabled}
                  >
                    <img
                      src={"../input-logos/calander.svg"}
                      alt="Open calendar"
                      className="w-5 h-5 mr-5"
                    />
                  </button>
                ) : (
                  // Support either an image path string or a JSX node for rightIcon
                  typeof rightIcon === "string" ? (
                    <img src={rightIcon} alt="" className="w-5 h-5" />
                  ) : (
                    <span className="inline-flex items-center mr-2">{rightIcon}</span>
                  )
                )}
              </div>
            )}

            {isMonthField && showMonthPicker && !disabled && ReactDOM.createPortal(
              <div
                ref={monthPickerRef}
                className="fixed z-[9999] rounded-2xl border border-gray-200 bg-white p-3 shadow-xl"
                style={{ top: monthPickerStyle.top, left: monthPickerStyle.left, width: monthPickerStyle.width }}
              >
                <div className="flex items-center justify-between gap-2 mb-3">
                  <span className="text-sm font-semibold text-gray-700">Select month</span>
                  <select
                    value={String(monthPickerYear)}
                    onChange={(e) => setMonthPickerYear(Number(e.target.value))}
                    className="h-9 rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none"
                  >
                    {yearOptions.map((yr) => (
                      <option key={yr} value={yr}>{yr}</option>
                    ))}
                  </select>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  {monthOptionsForYear.map((month) => {
                    const current = `${String(monthPickerYear)}-${month.value}`;
                    return (
                      <button
                        key={month.value}
                        type="button"
                        onClick={() => {
                          onChange({ target: { name, value: current } });
                          setShowMonthPicker(false);
                        }}
                        className={`rounded-lg border px-3 py-2 text-sm transition ${String(value) === current
                            ? "border-violet-500 bg-violet-50 text-violet-700"
                            : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                      >
                        {month.label}
                      </button>
                    );
                  })}
                </div>
              </div>
              , document.body)}

            {isDateField && showDatePicker && !disabled && ReactDOM.createPortal(
              <div
                ref={datePickerRef}
                className="fixed z-[9999] w-[260px] max-w-[calc(100vw-24px)] overflow-hidden rounded-2xl border border-[#E6E2FF] bg-white shadow-xl"
                style={{ top: datePickerStyle.top, left: datePickerStyle.left }}
              >
                <div className="bg-gradient-to-b from-[#8862F2] via-[#7544FC] to-[#40248B] px-3 py-2.5 text-white">
                  <div className="flex items-center justify-between gap-1">
                    <button
                      type="button"
                      onClick={() => shiftDateViewMonth(-1)}
                      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/15 text-base transition hover:bg-white/25"
                      aria-label="Previous month"
                    >
                      ‹
                    </button>
                    <div className="flex min-w-0 flex-1 items-center justify-center gap-1.5">
                      <span className="truncate text-xs font-semibold">
                        {monthNames[dateViewMonth - 1]}
                      </span>
                      <select
                        value={String(dateViewYear)}
                        onChange={(e) => setDateViewYear(Number(e.target.value))}
                        className="h-7 max-w-[4.5rem] rounded-lg border border-white/20 bg-white/15 px-1.5 text-xs font-medium text-white outline-none"
                      >
                        {dateYearOptions.map((yr) => (
                          <option key={yr} value={yr} className="text-gray-800">
                            {yr}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button
                      type="button"
                      onClick={() => shiftDateViewMonth(1)}
                      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/15 text-base transition hover:bg-white/25"
                      aria-label="Next month"
                    >
                      ›
                    </button>
                  </div>
                </div>

                <div className="p-2">
                  <div className="mb-1.5 grid grid-cols-7 gap-0.5">
                    {weekdayLabels.map((label) => (
                      <div
                        key={label}
                        className="py-0.5 text-center text-[10px] font-semibold uppercase tracking-wide text-[#7544FC]"
                      >
                        {label}
                      </div>
                    ))}
                  </div>

                  <div className="grid grid-cols-7 gap-0.5">
                    {buildDateCalendarCells().map((cell) => {
                      if (cell.type === "empty") {
                        return <div key={cell.key} className="h-8" />;
                      }

                      const isSelected =
                        selectedDate?.year === dateViewYear &&
                        selectedDate?.month === dateViewMonth &&
                        selectedDate?.day === cell.day;
                      const isToday =
                        todayDate.year === dateViewYear &&
                        todayDate.month === dateViewMonth &&
                        todayDate.day === cell.day;
                      const disabledDay = isDateDisabled(dateViewYear, dateViewMonth, cell.day);

                      return (
                        <button
                          key={cell.key}
                          type="button"
                          disabled={disabledDay}
                          onClick={() => {
                            onChange({
                              target: {
                                name,
                                value: toISODateString(dateViewYear, dateViewMonth, cell.day),
                              },
                            });
                            setShowDatePicker(false);
                          }}
                          className={[
                            "h-8 rounded-md text-xs font-medium transition",
                            disabledDay
                              ? "cursor-not-allowed text-gray-300"
                              : isSelected
                                ? "bg-gradient-to-b from-[#8862F2] to-[#7544FC] text-white shadow-sm"
                                : isToday
                                  ? "border border-[#7544FC] bg-violet-50 text-[#7544FC] hover:bg-violet-100"
                                  : "text-gray-700 hover:bg-violet-50 hover:text-[#7544FC]",
                          ].join(" ")}
                        >
                          {cell.day}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
              , document.body)}
          </>
        )}
      </div>

      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

